import React from "react";
import { VoucherStatus } from "constant";
import { Stepper, Step, StepLabel } from "@material-ui/core";

function ActivityState(props) {
  let currentStateIndex = -1;
  for (const [, status] of Object.entries(VoucherStatus)) {
    if (status.displayName === props.currentState) {
      currentStateIndex = status.value;
    }
  }

  const elements = (
    <Stepper nonLinear orientation="vertical" activeStep={currentStateIndex}>
      {Object.keys(VoucherStatus).map((key) => {
        return (
          <Step key={key}>
            <StepLabel>{VoucherStatus[key].displayName}</StepLabel>
          </Step>
        );
      })}
    </Stepper>
  );

  return <React.Fragment>{elements}</React.Fragment>;
}

export default ActivityState;
